import { Component, Input, isDevMode, Signal } from '@angular/core';
import { Store } from '@ngxs/store';
import { CartActions } from '../../state/cart.actions';
import { CartState } from '../../state/cart.state';

export interface Items {
  name?: string;
  id?: string;
  permalink?: string;
  stock?: number;
  image?: string;
  price?: number;
}

@Component({
  selector: 'app-button-add-items',
  imports: [],
  templateUrl: './button-add-items.component.html',
  styleUrl: './button-add-items.component.scss',
  standalone: true
})
export class ButtonAddItemsComponent {
  @Input() item: any;
  @Input() qty: any;
  @Input() max: any;
  @Input() limit: any;

  _isDev = isDevMode();

  list: any;

  constructor(private store: Store) {
    this.store.select(CartState.getList).subscribe((res) => {
      this.list = res;

    });
    // this.list.
    // this.store.selectSignal(CartState.ad)
  }

  addItem(item: any) {
    //  validar si el producto tiene un limit, valida que ya exista en el carrigo o ngxs para que no agrege mas
    const list = this.list.find((res) => res.id === item.id_firebase);

    if (+this.qty.qty > 0 && +this.qty.qty <= +this.max) {
      if (list !== undefined && Object.keys(list).length >= 1) {
        const validate_stock = list.stock + this.qty.qty;
        if (validate_stock <= +this.max) {
          list.stock += this.qty.qty;
          this.store.dispatch(new CartActions.Update(list));
        } else {

          return false;
        }
      } else {
        let arr: any = [];
        let items: Items = {};
        let validate: any;
        let validateStock = false;

        let regular_price = 0
        if (item.price_currency[0].sale_price !== 0) {
          regular_price = +item.price_currency[0].sale_price
        }
        else {
          regular_price = +item.price_currency[0].regular_price
        }

        Object.assign(items, {
          name: item.name,
          id: item.id_firebase,
          permalink: item.permalink,
          stock: this.qty.qty,
          image: item.image[0].src,
          price: regular_price,
          count: item.stock,
        });
        // if (this.limit >= 1) {
        //   validate = arr.find(p => p.id === items?.id!)
        //   if (validate.stock >= this.limit) {
        //     validateStock = true;
        //   }
        // }
        // if (validateStock) {
        //   return false;
        // }
        // if (!validate) {
        //   arr.push(items);
        // }
        this.store.dispatch(new CartActions.Set(items));
      }
    } else {

      return false;
    }
    // return true;


    return true;
  }
  reset() {
    this.store.dispatch(new CartActions.Reset());
  }
}
